// Function to get the current timestamp and convert it to epoch time (in seconds)
function getCurrentEpochTime() {
  return Math.floor(Date.now() / 1000);
}

// Function to generate a unique identifier
function generateUniqueNumber() {
  return "xxxx-xxxx-xxxx-xxxx".replace(/[x]/g, () => {
    const random = (Math.random() * 16) | 0;
    return random.toString(16);
  });
}

// Function to get URL parameters as an object
function getUrlParams() {
  const params = new URLSearchParams(window.location.search);
  const paramObject = {};
  params.forEach((value, key) => {
    paramObject[key] = value;
  });
  return paramObject;
}

// Function to set a cookie with a JSON object and optional expiry (in days)
function setJsonCookie(name, jsonObject, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  const jsonString = JSON.stringify(jsonObject);
  document.cookie =
    encodeURIComponent(name) +
    "=" +
    encodeURIComponent(jsonString) +
    expires +
    "; path=/";
}

// Function to retrieve a specific cookie by name
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    try {
      const cookieValue = parts.pop().split(";").shift();
      const parsedValue = JSON.parse(decodeURIComponent(cookieValue));
      return parsedValue.uniqueNumber || 0;
    } catch (error) {
      console.error("Error parsing cookie:", error);
      return null;
    }
  }
  return null;
}

// Function to append query parameters to a URL if the value is present
function appendIfPresent(url, key, value) {
  if (value !== undefined && value !== null && value !== "") {
    url.searchParams.append(key, value);
  }
}

// Function to capture user details and send them to the backend
async function captureAndSendUserInfo() {
  const uniqueNumber = generateUniqueNumber();
  const params = getUrlParams();
  params.uniqueNumber = uniqueNumber;
  setJsonCookie("urlParams", params, 15);

  const url = new URL("https://partnersapi.fxview.com/tracker/logs");
  appendIfPresent(url, "url", window.location.href);
  appendIfPresent(url, "uniqueNumber", uniqueNumber);

  fetch(url.toString(), {
    method: "GET",
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", {
        error: error.message,
        responseStatus: error.status || "N/A",
      });
    });
}

function handleButtonClick(event) {
  const buttonValue = parseInt(event);
  const cookieId = getCookie("urlParams");

  if (cookieId != null) {
    const url = new URL(
      "https://partnersapi.fxview.com/tracker/logs/vendor/save"
    );
    url.searchParams.append("id", buttonValue);
    url.searchParams.append("uniqueNumber", cookieId || "");

    fetch(url.toString(), {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

// Export functions
export { handleButtonClick, captureAndSendUserInfo };



//////////////////
// WEBPACK FOOTER
// ./tracker.js
// module id = /mce
// module chunks = 4